export default {
  width: 22,
  height: 21,
  stroke: true,
  svg: `
  <svg fill="none">
    <path d="M5.49316 5.50847C5.49316 3.01851 7.51167 1 10.0016 1C12.4916 1 14.5101 3.01851 14.5101 5.50847C14.5101 7.99844 12.4916 10.661 10.0016 10.661C7.51167 10.661 5.49316 7.99844 5.49316 5.50847Z" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.8665 13.5613C12.7845 13.3677 11.4992 13.2373 10.0018 13.2373C6.41433 13.2373 4.04609 13.988 2.77116 14.5535C2.07299 14.8629 1.62891 15.5547 1.62891 16.3182V19.678H10.0018" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.8321 19.6779L12.8999 20L13.2219 18.0678L18.6965 12.5932L20.3067 14.2034L14.8321 19.6779Z" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

  `
}
